import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  InputLabel,
  Stack,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import { Delete } from "@mui/icons-material";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import CustomTextField from "../CustomComponents/CustomTextField";
import AddIcon from "@mui/icons-material/Add";
import store from "../Store";
import axios from "axios";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import SearchIcon from "@mui/icons-material/Search";
import NoDataFound from "../CustomComponents/NoDataFound";
import { DataGrid } from "@mui/x-data-grid";
import { makeStyles } from "@mui/styles";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import dayjs from "dayjs";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import { useDispatch, useSelector } from "react-redux";
import StlapFooter from "../CustomComponents/StlapFooter";

const useStyles = makeStyles({
  dataGridContainer: {
    cursor: "pointer",
  },
});
const LosMaster = () => {
  const [rows, setRows] = useState([]);
  //List State
  const [displayDetail, setDisplayDetail] = useState(false);
  const [feeList, setFeeList] = useState([]);
  const [userName, setUserName] = useState("");
  //Dialog State Handler
  const [branchDialogOpen, setBranchDialogOpen] = useState(null);
  //InformationDialogHandler
  const [informationDialogOpen, setInformationDialogOpen] = useState(false);
  const [informationDialogMessage, setInformationDialogMessage] = useState();
  const [resetMode, setResetMode] = useState(null);

  //Confirmation Dialog
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [confirmationDialogMessage, setConfirmationDialogMessage] = useState();
  const [confirmationDialogMode, setConfirmationDialogMode] = useState(null);
  const [discardMode, setDiscardMode] = useState(null);
  //Maintaining active value
  const [activeValue, setActiveValue] = useState(null);
  //Data Grid State Handler
  const [percentageEnable, setPercentageEnable] = useState(null);
  const [flatEnable, setFlatEnable] = useState(null);
  const columnsBranch = [
    {
      field: "branch_name",
      headerName: "Branch",
      headerAlign: "center",
      align: "left",
      flex: 350,
      type: "string",
      editable: false,
    },
  ];
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedBranchRows, setSelectedBranchRows] = useState([]);
  const [datarowsBranch, setDatarowsBranch] = useState([]);
  const [branchWithCode, setBranchWithCode] = useState();
  const [columnsBranchData, setBranchColumns] = useState(columnsBranch);

  //TouchHandler
  const [branchTouchHandler, setBranchTouchHandler] = useState(false);
  const [feeTypeTouchHandler, setFeeTouchHandler] = useState(false);
  const [effectiveTouchHandler, setEffectiveTouchHandler] = useState(false);
  const [tenureTouchHandler, setTenureTouchHandler] = useState(false);
  //Value State
  const [feeValue, setFeeValue] = useState("");
  const [effectiveDateValue, setEffectiveDateValue] = useState("");
  const [tenureValue, setTenureValue] = useState("");
  //Valid State
  const branchIsValid = selectedRow.length > 0;
  const feeIsValid = feeValue != "" && feeValue !== null;
  const effectiveDateIsValid =
    effectiveDateValue !== "" && effectiveDateValue !== null;
  const tenureValueIsValid =
    tenureValue !== "" && tenureValue !== null && tenureValue <= 120;

  //Has Error
  const branchHasError = branchTouchHandler && !branchIsValid;
  const feeValueHasError = feeTypeTouchHandler && !feeIsValid;
  const effectiveDateHasError = effectiveTouchHandler && !effectiveDateIsValid;
  const tenureHasError = tenureTouchHandler && !tenureValueIsValid;

  let activeRowID = [];
  const dispatch = useDispatch();
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);

  //field access
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let minDateFromValue = Number(0);
  let maxDateFromValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Los Master Effective Date Back Count"] &&
        new Date(
          paramValues["Los Master Effective Date Back Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Los Master Effective Date Back Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateFromValue = 0;
    } else {
      minDateFromValue =
        fieldAccessMap.losMasterEffectiveDate &&
        fieldAccessMap.losMasterEffectiveDateBackCount
          ? Number(
              paramValues["Los Master Effective Date Back Count"]["paramValue"]
            )
          : Number(0);
    }
    if (
      !(
        paramValues["Los Master Effective Date Future Count"] &&
        new Date(
          paramValues["Los Master Effective Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Los Master Effective Date Future Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateFromValue = 0;
    } else {
      maxDateFromValue =
        fieldAccessMap.losMasterEffectiveDate &&
        fieldAccessMap.losMasterEffectiveDateFutureCount
          ? Number(
              paramValues["Los Master Effective Date Future Count"][
                "paramValue"
              ]
            )
          : Number(0);
    }
  }

  useEffect(() => {
    getFeeType();
    const users = store.getState().branch.userName;
    setUserName(users);
    const branchValues = GetBranchDetails();
    const branchWithCode = GetBranchDetailsWithCode();
    const branchArrayList = branchValues.map((branch, index) => {
      return {
        id: index,
        branch_name: branch.label,
      };
    });
    setDatarowsBranch(branchArrayList);
    setBranchWithCode(branchWithCode);
  }, []);
  const getFeeType = async () => {
    try {
      const nachLovValues = await axios.post("/lovMaster/getLovValues", {
        moduleId: "MD016",
      });
      const feeListMap = nachLovValues.data["Fee Type"].map((type) => {
        return type.lovValues;
      });
      setFeeList(feeListMap);
    } catch (e) {}
  };
  const cellChangeHandler = (params) => {
    const dataIndex = rows.findIndex((data) => {
      return data.id === params.id;
    });
    if (params.field === "percentage") {
      if (params.value > 99.99 || params.value < 0) {
        let data = rows[dataIndex];
        const datas = { ...data, percentage: 0 };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      } else {
        let data = rows[dataIndex];
        const datas = { ...data, percentage: params.value };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      }
    } else if (params.field === "flatRate") {
      if (params.value > 999999 || params.value < 0) {
        let data = rows[dataIndex];
        const datas = { ...data, flatRate: 0 };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      } else {
        let data = rows[dataIndex];
        const datas = { ...data, flatRate: params.value };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      }
    } else if (params.field === "toAmt") {
      if (params.value > 2000000 || params.value < 0) {
        let data = rows[dataIndex];
        const datas = { ...data, toAmt: 0 };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      } else {
        let data = rows[dataIndex];
        const datas = { ...data, toAmt: params.value };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      }
    } else {
      let data = rows[dataIndex];
      const datas = { ...data, [params.field]: params.value };
      let newItem = [...rows];
      newItem[dataIndex] = datas;
      setRows(newItem);
    }
  };
  const confirmationDialogOnOkHandler = () => {
    setConfirmationDialogOpen(false);
    switch (feeValue) {
      case "ST - PROCESSING FEES":
        sendData(
          "/processingfeemaster/insertProcessingFee",
          "processingAmountModel"
        );
        break;
      case "ST - EXTERNAL LEGAL FEES":
        sendData("/legalfeemaster/insertLegalFee", "legalAmountModel");
        break;
      case "ST - EXTERNAL TECHNICAL FEES":
        sendData(
          "/technicalfeemaster/insertTechnicalFee",
          "technicalAmountModel"
        );
        break;
      case "ST - DOCUMENTATION CHARGES":
        sendData(
          "/documentchargefeemaster/insertDocumentChargeFee",
          "documentChargeAmountModel"
        );
        break;
    }
  };

  const columnsData = [
    {
      field: "product",
      headerName: "Product",
      headerAlign: "center",
      flex: 280,
      align: "left",
      editable: false,
    },
    {
      field: "fromAmt",
      headerName: "From Amount (₹)",
      headerAlign: "center",
      flex: 280,
      type: "number",
      align: "right",
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "toAmt",
      headerName: "To Amount (₹)",
      headerAlign: "center",
      align: "right",
      editable: true,
      type: "number",
      flex: 280,
      renderCell: (params) => {
        return params.value !== "" && params.value !== null
          ? parseInt(params.value).toLocaleString("en-IN")
          : params.value;
      },
    },
    {
      field: "percentage",
      headerName: "Percentage (%)",
      headerAlign: "center",
      flex: 260,
      align: "right",
      type: "number",
      editable: percentageEnable,
    },

    {
      field: "flatRate",
      headerName: "Flat Rate",
      headerAlign: "center",
      align: "right",
      flex: 232,
      editable: flatEnable,
      type: "number",
      renderCell: (params) => {
        return params.value !== "" && params.value !== null
          ? parseInt(params.value).toLocaleString("en-IN")
          : "";
      },
    },

    {
      field: "icon",
      headerName: "",
      headerAlign: "center",
      align: "left",
      flex: 25,
      type: "number",
      disableColumnMenu: true,
      sortable: false,

      renderCell: (params) => {
        return (
          <Tooltip title="Delete">
            <Delete
              onClick={() => {
                deleteSelectedRow(params);
              }}
            ></Delete>
          </Tooltip>
        );
      },
    },
  ];

  const deleteSelectedRow = (param) => {
    let toAmountValue = -1;
    let newRow = [];
    let count = 0;
    rows.forEach((data, index) => {
      if (param.id !== data.id) {
        if (data["fromAmt"] - 1 === toAmountValue) {
          toAmountValue = data["toAmt"];
        } else {
          data["fromAmt"] = toAmountValue + 1;
          toAmountValue = data["toAmt"];
        }
        data["id"] = count++;
        newRow.push(data);
      }
    });
    setRows(newRow);
  };
  const gridRowAddButtonHandler = () => {
    if (rows.length === 0) {
      let newRow = {
        id: 0,
        product: "SHFL",
        fromAmt: 0,
        toAmt: 0,
        percentage: "",
        flatRate: "",
        flag: false,
      };
      setRows((prevRows) => [...prevRows, newRow]);
    } else {
      if (
        rows[rows.length - 1]["toAmt"].toString() &&
        rows[rows.length - 1]["toAmt"] > 0 &&
        rows[rows.length - 1]["fromAmt"].toString()
      ) {
        let newRow = {
          id: rows.length,
          product: "SHFL",
          fromAmt: !rows[rows.length - 1]
            ? 0
            : rows[rows.length - 1]["toAmt"] + 1,
          toAmt: 0,
          percentage: "",
          flatRate: "",
          flag: false,
        };
        if (newRow.fromAmt >= 2000000) {
          setInformationDialogOpen(true);
          setResetMode(false);
          setInformationDialogMessage("Limits Exceed more than 2000000");
        } else {
          setRows((prevRows) => [...prevRows, newRow]);
        }
      }
    }
  };

  const doCheckIsDataValidated = () => {
    let saveFlag = true;
    let lastReceiptAmount = 0;
    rows.forEach((value, index) => {
      if (
        lastReceiptAmount <= value["fromAmt"] &&
        value["fromAmt"] < value["toAmt"] &&
        (value["flatRate"] !== "" ||
          (value["percentage"] !== "" && value["percentage"] > 0))
      ) {
        lastReceiptAmount = value["toAmt"];
      } else {
        saveFlag = false;
      }
    });
    return saveFlag;
  };
  const NoRowsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <NoDataFound message="No Data." />
      </Stack>
    );
  };

  const NoResultsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <NoDataFound message="No Data on Applied Filter." />
      </Stack>
    );
  };
  const saveButtonHandler = () => {
    if (doCheckIsDataValidated()) {
      setConfirmationDialogMode(true);
      setConfirmationDialogOpen(true);
      setConfirmationDialogMessage("Confirmation for Create ? ");
    } else {
      setResetMode(false);
      setInformationDialogMessage(
        "Range is not properly entered/Percentage or Flat Rate can't be 0"
      );
      setInformationDialogOpen(true);
    }
  };
  const getHandler = (tenureValue) => {
    switch (feeValue) {
      case "ST - PROCESSING FEES":
        getData(
          "/processingfeemaster/getByEffectiveDate",
          tenureValue,
          "processingFeeList"
        );
        break;
      case "ST - EXTERNAL LEGAL FEES":
        getData(
          "/legalfeemaster/getByEffectiveDate",
          tenureValue,
          "legalFeeList"
        );
        break;
      case "ST - EXTERNAL TECHNICAL FEES":
        getData(
          "/technicalfeemaster/getByEffectiveDate",
          tenureValue,
          "technicalFeeList"
        );
        break;
      case "ST - DOCUMENTATION CHARGES":
        getData(
          "/documentchargefeemaster/getByEffectiveDate",
          tenureValue,
          "documentChargeFeeList"
        );
        break;
    }
  };
  const branchOnChangeHandler = () => {
    setBranchDialogOpen(true);
    setBranchTouchHandler(true);
  };
  const feeTypeOnChangeHandler = (value) => {
    if (displayDetail) {
      setActiveValue(value);
      setConfirmationDialogOpen(true);
      setConfirmationDialogMode(false);
      setConfirmationDialogMessage("Do you want to Discard changes ?");
      setDiscardMode("feeType");
    } else {
      setFeeValue(value);
      setTenureValue("");
      setSelectedRow([]);
    }
  };
  const tenureOnChangeHandler = (value) => {
    if (displayDetail) {
      setActiveValue(value);
      setConfirmationDialogOpen(true);
      setConfirmationDialogMode(false);
      setConfirmationDialogMessage("Do you want to Discard changes ?");
      setDiscardMode("tenure");
    } else {
      setTenureValue(value);
      setSelectedRow([]);
    }
  };

  const getData = async (URL, tenure, key) => {
    let newAxiosBase = { ...axios };
    newAxiosBase.defaults.baseURL =
      process.env.REACT_APP_STLAP_LOS_MASTER_SCREEN_UI_BACKEND;
    const response = await newAxiosBase.post(URL, {
      effectiveDate: new Date(effectiveDateValue).toLocaleDateString("fr-FR"),
      feeType: feeValue,
      tenure: Number(tenure),
    });
    if (response.data.flag) {
      response.data.branch.forEach((data) => {
        datarowsBranch.map((branch) => {
          if (branch.branch_name === data) {
            activeRowID.push(branch.id);
          }
        });
      });
      let branchArray = response.data.branch.map((data) => {
        return {
          branch_name: data,
        };
      });
      setSelectedBranchRows(branchArray);
      setSelectedRow(activeRowID);
      const responseWithKey = response.data[key].map((data) => {
        return {
          ...data,
          id: data.fromAmt,
          percentage: data.percentage === 0.0 ? "" : data.percentage,
          flatRate: data.flatRate === 0 ? "" : data.flatRate,
        };
      });
      setRows(responseWithKey);
      setDisplayDetail(true);
    } else {
      setSelectedBranchRows([]);
      setRows([]);
    }
  };

  const sendData = async (URL, modalKey) => {
    let branchWithCde = [];
    selectedBranchRows.forEach((branch) => {
      branchWithCode.forEach((code) => {
        if (code.label === branch.branch_name) {
          branchWithCde.push(code);
        }
      });
    });
    let newAxiosBase = { ...axios };
    newAxiosBase.defaults.baseURL =
      process.env.REACT_APP_STLAP_LOS_MASTER_SCREEN_UI_BACKEND;
    const response = await newAxiosBase.post(URL, {
      branch: selectedBranchRows.map((branch) => {
        return branch.branch_name;
      }),
      branchWithCode: branchWithCde,
      createdBy: userName,
      effectiveDate: new Date(effectiveDateValue).toLocaleDateString("fr-FR"),
      feeType: feeValue,
      lastModifiedBy: userName,
      [modalKey]: rows,
      tenure: tenureValue,
    });
    if (response.status === 200) {
      setResetMode(true);
      setInformationDialogMessage(`${feeValue} Master Inserted Successfully.`);
      setInformationDialogOpen(true);
    } else {
      setResetMode(true);
      setInformationDialogMessage("Unable to Insert Los Master");
      setInformationDialogOpen(true);
    }
  };
  const goButtonHandler = () => {
    setBranchTouchHandler(true);
    setFeeTouchHandler(true);
    setEffectiveTouchHandler(true);
    setTenureTouchHandler(true);
    if (
      branchIsValid &&
      feeIsValid &&
      effectiveDateIsValid &&
      tenureValueIsValid
    ) {
      setDisplayDetail(true);
    }
  };
  const discardDialogOkButtonHandler = () => {
    switch (discardMode) {
      case "EffectiveDate":
        setEffectiveDateValue(activeValue);
        setFeeValue("");
        setTenureValue("");
        setSelectedRow([]);
        setConfirmationDialogOpen(false);
        setRows([]);
        setDisplayDetail(false);
        break;
      case "feeType":
        setFeeValue(activeValue);
        setTenureValue("");
        setSelectedRow([]);
        setConfirmationDialogOpen(false);
        setRows([]);
        setDisplayDetail(false);
        break;
      case "tenure":
        setTenureValue(activeValue);
        setConfirmationDialogOpen(false);
        setRows([]);
        setSelectedRow([]);
        setDisplayDetail(false);
        break;
      case "branch":
        setBranchDialogOpen(true);
        setBranchTouchHandler(true);
        setTenureValue("");
        setConfirmationDialogOpen(false);
        setSelectedRow([]);
        setRows([]);
        setDisplayDetail(false);
        break;
    }
  };
  const effectiveDateOnChangeHandler = (value) => {
    if (displayDetail) {
      setActiveValue(value);
      setConfirmationDialogOpen(true);
      setConfirmationDialogMode(false);
      setConfirmationDialogMessage("Do you want to Discard Changes ?");
      setDiscardMode("EffectiveDate");
    } else {
      setEffectiveDateValue(value);
      setFeeValue("");
      setTenureValue("");
      setSelectedRow([]);
    }
  };
  const ClearButtonHandler = () => {
    setSelectedBranchRows([]);
    setDisplayDetail(false);
    setFeeValue("");
    setEffectiveDateValue(null);
    setTenureValue("");
    setBranchTouchHandler(false);
    setFeeTouchHandler(false);
    setEffectiveTouchHandler(false);
    setTenureTouchHandler(false);
    setSelectedRow([]);
  };
  const classes = useStyles();
  return (
    <>
      <Box sx={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          title="LOS Master"
          initialOpen={true}
          sx={{ margin: "8px !important" }}
        >
          <Box sx={{ marginTop: "-1%" }}>
            <Grid container rowSpacing={0} columnSpacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  type="date"
                  label="Effective Date"
                  variant="standard"
                  required={true}
                  maxDate={new Date().setDate(
                    new Date().getDate() + maxDateFromValue
                  )}
                  minDate={new Date().setDate(
                    new Date().getDate() - minDateFromValue
                  )}
                  value={effectiveDateValue}
                  onChange={(value) => {
                    effectiveDateOnChangeHandler(value);
                    setFeeTouchHandler(false);
                  }}
                  onBlur={() => {
                    setEffectiveTouchHandler(true);
                  }}
                ></CustomDateField>
                {effectiveDateHasError && (
                  <p className="error">Please Select Effective Date</p>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Fee Type"
                  label="Fee Type"
                  required={effectiveDateIsValid}
                  value={feeValue}
                  disabled={
                    effectiveDateValue === null || effectiveDateValue === ""
                  }
                  autoCompleteValues={feeList}
                  onBlur={() => {
                    setFeeTouchHandler(true);
                  }}
                  onChange={(e, value) => {
                    feeTypeOnChangeHandler(value);
                    setTenureTouchHandler(false);
                  }}
                />
                {feeValueHasError && effectiveDateIsValid && (
                  <p className="error">Please Select Fee Type</p>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  required={feeIsValid}
                  type="text"
                  label="Tenure"
                  variant="standard"
                  value={tenureValue}
                  disabled={
                    effectiveDateValue === null ||
                    effectiveDateValue === "" ||
                    feeValue === null ||
                    feeValue === ""
                  }
                  onChange={(event) => {
                    tenureOnChangeHandler(event.target.value);
                    setBranchTouchHandler(false);
                  }}
                  onBlur={() => {
                    setTenureTouchHandler(true);
                    getHandler(tenureValue);
                  }}
                ></CustomTextField>
                {tenureHasError && feeIsValid && (
                  <p className="error">Please Enter Valid Tenure</p>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                <InputLabel
                  required={tenureValueIsValid}
                  size="small"
                  sx={{
                    color: "#004A92",
                    mb: 2,
                    fontWeight: 400,
                    fontSize: "14px",
                  }}
                >
                  Select branch
                </InputLabel>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Tooltip title="Select Branch">
                    <IconButton
                      aria-label="more"
                      id="long-button"
                      aria-haspopup="true"
                      onClick={() => {
                        branchOnChangeHandler();
                      }}
                      disabled={
                        effectiveDateValue === null ||
                        effectiveDateValue === "" ||
                        feeValue === null ||
                        feeValue === "" ||
                        tenureValue === "" ||
                        tenureValue === null
                      }
                    >
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>
                  <p className="info">
                    {selectedRow.length} Branch is Selected
                  </p>
                </Box>
                {branchHasError && tenureValueIsValid && (
                  <p className="error">Please Select Branch</p>
                )}
              </Grid>
            </Grid>
            <Box
              sx={{
                marginTop: "8px",
                marginBottom: "4px",
                display: "flex",
                gap: "8px",
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                type="submit"
                sx={{ height: "2rem", fontWeight: "bold" }}
                onClick={goButtonHandler}
              >
                GO
              </Button>
              <Button
                sx={{
                  color: "white",
                  backgroundColor: "black",
                  height: "2rem",
                  fontWeight: "bold",
                }}
                onMouseOver={({ target }) => {
                  target.style.backgroundColor = "black";
                  target.style.color = "white";
                }}
                variant="contained"
                onClick={ClearButtonHandler}
              >
                Clear
              </Button>
            </Box>
          </Box>
        </AccordianContainer>
        {displayDetail && (
          <Box
            sx={{
              color: "red",
              background: "white",
              padding: "0.8rem",
              borderRadius: "0.4rem",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "right",
                marginBottom: "8px",
              }}
            >
              <Tooltip title="Add">
                <Button
                  variant="contained"
                  onClick={gridRowAddButtonHandler}
                  sx={{
                    marginLeft: "1rem",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  <AddIcon />
                </Button>
              </Tooltip>
              <Tooltip title="Save">
                <Button
                  sx={{ fontWeight: "bold", marginLeft: "12px" }}
                  variant="contained"
                  onClick={saveButtonHandler}
                  disabled={
                    rows.length == 0 || !branchIsValid || !tenureValueIsValid
                  }
                >
                  <SaveIcon />
                </Button>
              </Tooltip>
            </Box>
            <CustomDataGrid
              noDataMessage="No Data."
              noDataOnFilterMessage="No Data on Applied Filter."
              rows={rows}
              columns={columnsData}
              pageSizeOptions={[5, 10, 15, 20, 25]}
              onCellEditCommit={(params) => {
                cellChangeHandler(params);
              }}
              isCellEditable={() => true}
              onCellKeyDown={(params, event) => {
                (event.key === "e" ||
                  event.key === "E" ||
                  event.key.includes("-")) &&
                  event.preventDefault();
              }}
              onRowClick={(params) => {
                if (
                  (params.row.percentage === "" ||
                    params.row.percentage === null) &&
                  (params.row.flatRate === "" || params.row.flatRate === null)
                ) {
                  setPercentageEnable(true);
                  setFlatEnable(true);
                } else if (
                  (params.row.percentage === "" ||
                    params.row.percentage === null) &&
                  (params.row.flatRate !== "" || params.row.flatRate !== null)
                ) {
                  setPercentageEnable(false);
                  setFlatEnable(true);
                } else if (
                  (params.row.percentage !== "" ||
                    params.row.percentage !== null) &&
                  (params.row.flatRate === "" || params.row.flatRate === null)
                ) {
                  setPercentageEnable(true);
                  setFlatEnable(false);
                }
              }}
              gridLazyLoad={() => {}}
              onSortModelChange={() => {}}
            />
          </Box>
        )}
        <Dialog open={branchDialogOpen} maxWidth="sm" fullWidth>
          <DialogTitle>
            <h4>Select Branch</h4>
          </DialogTitle>
          <DialogContent>
            <div className={classes.dataGridContainer}>
              <DataGrid
                sx={{
                  boxShadow: 2,
                  border: 2,
                  height: "320px",
                  width: "100%",
                  borderColor: "white",
                  "& .MuiDataGrid-row:hover": {
                    color: "#004A92",
                    backgroundColor: "#B8E4F4",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    color: "white",

                    backgroundColor: "#004A92",
                  },
                }}
                rows={datarowsBranch}
                columns={columnsBranchData}
                pageSize={10}
                headerHeight={48}
                rowHeight={52}
                pageSizeOptions={[10]}
                gridLazyLoad={() => {}}
                gridHeight={305}
                onCellKeyDown={(event, param) => {
                  (param.key === "e" || param.key === "E") &&
                    param.preventDefault();
                }}
                checkboxSelection
                onSelectionModelChange={(ids) => {
                  const selectedIDs = new Set(ids);
                  const selectedBranchRows = datarowsBranch.filter((row) =>
                    selectedIDs.has(row.id)
                  );
                  setSelectedBranchRows(selectedBranchRows);
                  setSelectedRow(ids);
                }}
                selectionModel={selectedRow}
                getRowClassName={(params) =>
                  params.id % 2
                    ? `super-app-theme--even`
                    : `super-app-theme--odd`
                }
                components={{ NoRowsOverlay, NoResultsOverlay }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setBranchDialogOpen(false);
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={informationDialogOpen}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Information</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {informationDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {resetMode ? (
              <Button
                onClick={() => {
                  window.location.reload();
                  setInformationDialogOpen(false);
                }}
              >
                Ok
              </Button>
            ) : (
              <Button
                onClick={() => {
                  setInformationDialogOpen(false);
                }}
              >
                Ok
              </Button>
            )}
          </DialogActions>
        </Dialog>
        <Dialog
          open={confirmationDialogOpen}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Confirmation</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {confirmationDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {confirmationDialogMode ? (
              <>
                <Button
                  onClick={() => {
                    setConfirmationDialogOpen(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    confirmationDialogOnOkHandler();
                  }}
                >
                  Yes
                </Button>
              </>
            ) : (
              <>
                <Button
                  onClick={() => {
                    setConfirmationDialogOpen(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    discardDialogOkButtonHandler();
                  }}
                >
                  Yes
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>
      </Box>
      <StlapFooter />
    </>
  );
};
export default LosMaster;
